<template>
  <v-container>
    <v-container class="audioPlayer" v-show="isShowingPlayer">
      <div class="flex align-center justify-between">
        <a
          class="nav-icon !p-2"
          v-on:click="isPlaylistActive = !isPlaylistActive"
          :class="{ isActive: isPlaylistActive }"
          title="Music List"
        >
          <span></span>
          <span></span>
          <span></span>
        </a>
        <v-card-title class="justify-center text-center !p-0">
          <h4 :class="`${routeLink}_fortext !text-2xl font-Handel uppercase`">
            Magnum-XL
          </h4>
        </v-card-title>
        <v-btn
          @click="$store.dispatch('setMiniPlayerVisibility')"
          icon
          v-show="!premiumLayout"
        >
          <v-icon color="white">mdi-chevron-down</v-icon>
        </v-btn>
      </div>
      <div class="audioPlayerList" :class="{ isActive: isPlaylistActive }">
        <div
          class="item"
          v-for="(item, index) in musicPlaylist"
          v-bind:class="{ isActive: isCurrentSong(index) }"
          v-on:click="changeSong(index), (isPlaylistActive = !isPlaylistActive)"
          :key="index"
        >
          <p class="title">{{ item.title }}</p>
          <p class="artist">{{ item.artist }}</p>
        </div>
      </div>
      <div class="audioPlayerUI" :class="{ isDisabled: isPlaylistActive }">
        <div class="flex">
          <div class="albumImage">
            <transition
              name="ballmove"
              enter-active-class="animated zoomIn"
              leave-active-class="animated fadeOutDown"
              mode="out-in"
            >
              <!--<transition name="slide-fade" mode="out-in">-->
              <img
                @load="onImageLoaded()"
                :src="musicPlaylist[currentSong].image"
                :key="currentSong"
                ondragstart="return false;"
                id="playerAlbumArt"
              />
            </transition>
            <div class="loader" :key="currentSong">Loading...</div>
          </div>
          <div class="albumDetails pl-3 text-left">
            <transition name="slide-fade" mode="out-in">
              <p class="title" :key="currentSong">
                {{ musicPlaylist[currentSong].title }}
              </p>
            </transition>
            <transition name="slide-fade" mode="out-in">
              <p class="artist" :key="currentSong">
                {{ musicPlaylist[currentSong].artist }}
              </p>
            </transition>
          </div>
        </div>

        <div class="playerButtons flex align-center justify-center">
          <a
            class="button"
            :class="{ isDisabled: currentSong == 0 }"
            v-on:click="prevSong()"
            title="Previous Song"
          >
            <v-icon color="white">mdi-skip-previous</v-icon>
          </a>
          <a class="button play" v-on:click="playAudio()" title="Play/Pause Song">
            <transition name="slide-fade" mode="out-in">
              <v-icon :key="1" color="white" class="!text-4xl">
                {{
                  currentlyStopped
                    ? "mdi-stop"
                    : currentlyPlaying
                    ? "mdi-pause-circle"
                    : "mdi-play-circle"
                }}
              </v-icon>
            </transition>
          </a>
          <a
            class="button"
            :class="{ isDisabled: currentSong == musicPlaylist.length - 1 }"
            v-on:click="nextSong()"
            title="Next Song"
          >
            <v-icon color="white">mdi-skip-next</v-icon>
          </a>
        </div>

        <div class="currentTimeContainer" style="text-align: center">
          <span class="currentTime">{{ currentTime | fancyTimeFormat }}</span>
          <span class="totalTime"> {{ trackDuration | fancyTimeFormat }}</span>
          <!--<span style="color:black">({{ currentSong+1 }}/{{ musicPlaylist.length }})</span>-->
        </div>

        <div class="currentProgressBar">
          <div class="currentProgress" :style="{ width: currentProgressBar + '%' }"></div>
        </div>
      </div>
    </v-container>
    <v-tooltip top dark color="black">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          fab
          dark
          x-large
          class="!rounded-[30px] shadow-2xl !absolute !bottom-10 !right-10 z-10"
          v-bind="attrs"
          v-on="on"
          @click="$store.dispatch('setMiniPlayerVisibility')"
          v-show="!isShowingPlayer && !premiumLayout && !isMobile"
          elevation="5"
          color="black"
        >
          <v-icon x-large color="#1ed760"> mdi-music-circle </v-icon>
        </v-btn>
      </template>
      <span :class="`${routeLink}_fortext`">Music Player</span>
    </v-tooltip>
    <SubscribePremiumDialog />
  </v-container>
</template>
<script>
import SubscribePremiumDialog from "../settings/SubscribePremiumDialog.vue";

export default {
  name: "MusicPlayer",
  data() {
    return {
      audio: "",
      imgLoaded: false,
      currentlyPlaying: false,
      currentlyStopped: false,
      currentTime: 0,
      checkingCurrentPositionInTrack: "",
      trackDuration: 0,
      currentProgressBar: 0,
      isPlaylistActive: false,
      currentSong: 0,
      musicPlaylist: [
        {
          title: "Service Bell",
          artist: "Daniel Simion",
          url: "https://soundbible.com/mp3/service-bell_daniel_simion.mp3",
          image: "https://source.unsplash.com/crs2vlkSe98/400x400",
        },
        {
          title: "Meadowlark",
          artist: "Daniel Simion",
          url: "https://soundbible.com/mp3/meadowlark_daniel-simion.mp3",
          image: "https://source.unsplash.com/35bE_njbG9E/400x400",
        },
        {
          title: "Hyena Laughing",
          artist: "Daniel Simion",
          url: "https://soundbible.com/mp3/hyena-laugh_daniel-simion.mp3",
          image: "https://source.unsplash.com/Esax9RaEl2I/400x400",
        },
        {
          title: "Creepy Background",
          artist: "Daniel Simion",
          url: "http://soundbible.com/mp3/creepy-background-daniel_simon.mp3",
          image: "https://source.unsplash.com/j0g8taxHZa0/400x400",
        },
      ],
      audioFile: "",
    };
  },
  mounted: function () {
    this.changeSong();
    this.audio.loop = false;
  },
  computed: {
    isShowingPlayer() {
      return this.$store.getters.SpotifyPlayerVisibility;
    },
    premiumLayout() {
      return this.$store.getters.isPremiumLayout;
    },
  },
  filters: {
    fancyTimeFormat: function (s) {
      return (s - (s %= 60)) / 60 + (9 < s ? ":" : ":0") + s;
    },
  },
  methods: {
    togglePlaylist: function () {
      this.isPlaylistActive = !this.isPlaylistActive;
    },
    nextSong: function () {
      if (this.currentSong < this.musicPlaylist.length - 1)
        this.changeSong(this.currentSong + 1);
    },
    prevSong: function () {
      if (this.currentSong > 0) this.changeSong(this.currentSong - 1);
    },
    changeSong: function (index) {
      var wasPlaying = this.currentlyPlaying;
      this.imageLoaded = false;
      if (index !== undefined) {
        this.stopAudio();
        this.currentSong = index;
      }
      this.audioFile = this.musicPlaylist[this.currentSong].url;
      this.audio = new Audio(this.audioFile);
      var localThis = this;
      this.audio.addEventListener("loadedmetadata", function () {
        localThis.trackDuration = Math.round(this.duration);
      });
      this.audio.addEventListener("ended", this.handleEnded);
      if (wasPlaying) {
        this.playAudio();
      }
    },
    isCurrentSong: function (index) {
      if (this.currentSong == index) {
        return true;
      }
      return false;
    },
    getCurrentSong: function (currentSong) {
      return this.musicPlaylist[currentSong].url;
    },
    playAudio: function () {
      if (
        this.currentlyStopped == true &&
        this.currentSong + 1 == this.musicPlaylist.length
      ) {
        this.currentSong = 0;
        this.changeSong();
      }
      if (!this.currentlyPlaying) {
        this.getCurrentTimeEverySecond(true);
        this.currentlyPlaying = true;
        this.audio.play();
      } else {
        this.stopAudio();
      }
      this.currentlyStopped = false;
    },
    stopAudio: function () {
      this.audio.pause();
      this.currentlyPlaying = false;
      this.pausedMusic();
    },
    handleEnded: function () {
      if (this.currentSong + 1 == this.musicPlaylist.length) {
        this.stopAudio();
        this.currentlyPlaying = false;
        this.currentlyStopped = true;
      } else {
        this.currentlyPlaying = false;
        this.currentSong++;
        this.changeSong();
        this.playAudio();
      }
    },
    onImageLoaded: function () {
      this.imgLoaded = true;
    },
    getCurrentTimeEverySecond: function (startStop) {
      var localThis = this;
      this.checkingCurrentPositionInTrack = setTimeout(
        function () {
          localThis.currentTime = localThis.audio.currentTime;
          localThis.currentProgressBar =
            (localThis.audio.currentTime / localThis.trackDuration) * 100;
          localThis.getCurrentTimeEverySecond(true);
        }.bind(this),
        1000
      );
    },
    pausedMusic: function () {
      clearTimeout(this.checkingCurrentPositionInTrack);
    },
  },
  watch: {
    currentTime: function () {
      this.currentTime = Math.round(this.currentTime);
    },
  },
  beforeDestroy: function () {
    this.audio.removeEventListener("ended", this.handleEnded);
    this.audio.removeEventListener("loadedmetadata", this.handleEnded);
    clearTimeout(this.checkingCurrentPositionInTrack);
  },
  components: { SubscribePremiumDialog },
};
</script>
<!-- @import url("https://fonts.googleapis.com/css?family=Inconsolata:400,700");
  @import url("https://fonts.googleapis.com/css?family=Raleway:400,400i,700"); -->
<style scoped>
.straight_fortext {
  /* background: rgb(177, 145, 65); */
  background: linear-gradient(
    335deg,
    rgb(136 97 0) 0%,
    rgb(255 223 153) 53%,
    rgb(130 93 0 / 97%) 100%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.gay_fortext {
  /* background: rgb(177, 145, 65); */
  background: linear-gradient(357deg, rgba(0, 240, 255, 1) 55%, rgba(0, 156, 255, 1) 75%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.lesbian_fortext {
  /* background: rgb(177, 145, 65); */
  background: linear-gradient(
    208deg,
    rgba(126, 0, 157, 0.9416141456582633) 2%,
    rgba(161, 51, 246, 1) 45%,
    rgba(157, 0, 176, 0.9668242296918768) 96%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
</style>
<style lang="scss" scoped>
$primary_color: rgba(255, 255, 255, 0.916);
$player_width: 25rem;
$player_padding: 1.2rem;
$player_border_radius: 0.5rem;

$button_size: 2rem;

$anim_duration: 0.5s;

* {
  box-sizing: border-box;
}

.animated {
  animation-duration: $anim_duration;
}

.audioPlayer {
  position: relative;
  background-color: rgb(16 16 16 / 56%);
  backdrop-filter: blur(8px);
  width: $player_width;

  overflow: hidden;

  padding: $player_padding;
  margin: 0 auto;

  border-radius: $player_border_radius;
  box-shadow: 0 19px 38px rgba(0, 0, 0, 0.3), 0 15px 12px rgba(0, 0, 0, 0.22);

  user-select: none;

  .nav-icon {
    width: 15px;
    height: 12px;

    position: relative;

    transform: rotate(0deg);
    transition: 0.25s ease-in-out;
    cursor: pointer;

    span {
      display: block;
      position: absolute;
      height: 2px;
      width: 100%;
      background: $primary_color;
      border-radius: 6px;
      opacity: 1;
      left: 0;
      transform: rotate(0deg);
      transition: 0.5s ease-in-out;
    }

    span:nth-child(1) {
      top: 0px;
    }

    span:nth-child(2) {
      top: 5px;
    }

    span:nth-child(3) {
      top: 10px;
    }

    &.isActive span:nth-child(1) {
      top: 5px;
      transform: rotate(135deg);
    }

    &.isActive span:nth-child(2) {
      opacity: 0;
      left: -60px;
    }

    &.isActive span:nth-child(3) {
      top: 5px;
      transform: rotate(-135deg);
    }
  }

  .audioPlayerList {
    color: $primary_color;
    width: ($player_width)- (2 * $player_padding);
    transition: $anim_duration;
    transform: translateX(-200%);
    position: absolute;
    margin-top: 1rem;
    overflow: auto;
    z-index: 10;
    will-change: transform;
    height: calc(100% - 60px);

    &.isActive {
      transform: translateX(0);
    }

    .item {
      margin-bottom: 1.5rem;
      border-left: 0.1rem solid transparent;
      transition: 0.2s;

      &:hover {
        padding-left: 0.5rem;
        cursor: pointer;
      }

      .title {
        color: $primary_color;
        font-size: 1rem;
        margin-bottom: 0.75rem;
      }

      .artist {
        color: $primary_color;
        font-size: 0.8rem;
      }

      &.isActive {
        border-left-color: $primary_color;
        padding-left: 1rem;
      }
    }
  }

  .audioPlayerUI {
    margin-top: $player_padding;
    will-change: transform, filter;
    transition: $anim_duration;

    &.isDisabled {
      transform: scale(0.75) translateX(100%);
      filter: blur(5px) grayscale(100%);
    }

    .albumDetails {
      text-align: center;
      margin: auto 0;
      p {
        margin: 0px;

        &.title {
          font-size: 1rem;
          color: $primary_color;
        }

        &.artist {
          margin-top: 0.5rem;
          font-size: 0.75rem;
          font-weight: none;
          color: $primary_color;
          transition-delay: 100ms;
        }
      }
    }

    .albumImage {
      width: 80px;
      height: 80px;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
        z-index: 10;
        object-fit: cover;
        object-position: 50% 50%;
        border-radius: $player_border_radius;
      }
    }

    .playerButtons {
      position: relative;
      margin: 0 auto;
      //margin-bottom: 1.5rem;
      text-align: left;

      .button {
        font-size: $button_size;
        display: inline-block;
        vertical-align: middle;
        padding: 0.5rem;
        padding-bottom: 0;
        margin: 0 0.25rem;
        color: $primary_color !important;
        border-radius: 50%;
        line-height: 0px;

        outline: 0;
        text-decoration: none;
        cursor: pointer;
        transition: $anim_duration;

        &.play {
          font-size: 2 * $button_size;
          margin: 0 1.5rem;
        }

        &:active {
          opacity: 0.75;
          transform: scale(0.75);
        }

        &.isDisabled {
          color: rgba(0, 0, 0, 0.2);
          cursor: initial;
        }

        &.isDisabled:active {
          transform: none;
        }
      }
    }

    .currentTimeContainer {
      width: 100%;
      height: 1rem;

      display: flex;
      justify-content: space-between;

      .currentTime,
      .totalTime {
        font-size: 0.5rem;
        font-family: monospace;
        color: $primary_color;
      }
    }

    .currentProgressBar {
      width: 100%;
      background-color: #8d8d8db8;
      margin: 0.75rem 0;

      .currentProgress {
        background-color: #fff;
        width: 0px;
        height: 1px;
        transition: 100ms;
      }
    }
  }
}

.loader {
  margin: 60px auto;
  font-size: 10px;
  position: relative;
  text-indent: -9999em;
}

/* data change transitions */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}

.slide-fade-leave-active {
  transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(10px);
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity $anim_duration;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* pen specific formatting */
body {
  background: #29b6f6;

  color: rgba(255, 255, 255, 0.7);
  font-family: Raleway, sans-serif;

  padding: 3rem;
}

.heading {
  text-align: center;
  margin: 0;
  margin: 2rem 0;
  font-family: Inconsolata, monospace;

  h1 {
    color: #eceff1;
    margin: 0;
    margin-bottom: 1rem;
    font-size: 1.75rem;
  }

  p {
    margin: 0;
    font-size: 0.85rem;
  }

  a {
    color: rgba(255, 255, 255, 0.8);
    transition: 0.3s;
    text-decoration-style: dotted;

    &:hover {
      color: rgba(255, 255, 255, 1) !important;
    }

    &:visited {
      color: rgba(255, 255, 255, 0.5);
    }
  }
}
</style>
